export default "__VITE_ASSET__b4ec913f__"